import React from 'react';
export function BonusSection() {
  return null;
}